import { varsFromServer } from './client_side_injection_vars';
import Deferred from './deferred';
import 'whatwg-fetch';

// Remove once location search is merged
import algoliaClient from './util/algolia_client';

const ALGOLIA_GEOGROUPING_INDEX = varsFromServer.algoliaGeogroupingIndex;
const ALGOLIA_BUILDINGS_INDEX = varsFromServer.algoliaBuildingsIndex;
const LOCATION_MARKET_RADIUS_IN_METERS = 241402; // 150 miles
const MAX_NEARBY_MARKET = 1;

const geoDataDefer = new Deferred();

export const geoData = geoDataDefer.promise;

const DEFAULT_GEO = 'US';
const DEFAULT_LATITUDE = '40.792';
const DEFAULT_LONGITUDE = '-73.997';

function parseOverride(search) {
  if (search.includes('override_country=')) {
    const match = /override_country=([^&]+)/.exec(search);
    if (match && match.length > 1) {
      return match[1];
    }
  }
  return '';
}

export async function fetchGeoData() {
  const overrideCountry = parseOverride(window.location.search);

  if (overrideCountry) {
    geoDataDefer.resolve({
      countryCode: overrideCountry,
      latitude: DEFAULT_LATITUDE,
      longitude: DEFAULT_LONGITUDE
    });
    return;
  }

  const geoHeadersResponse = await fetch('/', { method: 'head' });
  geoDataDefer.resolve({
    countryCode: geoHeadersResponse.headers.get('GeoIP-Country-Code') || DEFAULT_GEO,
    latitude: geoHeadersResponse.headers.get('GeoIP-Latitude') || DEFAULT_LATITUDE,
    longitude: geoHeadersResponse.headers.get('GeoIP-Longitude') || DEFAULT_LONGITUDE
  });
}

export function updatePhoneNumbersWithGeoData(countryCode) {
  const geoPhoneData = varsFromServer.geoPhoneNumbers;
  const phoneDataForCountry = geoPhoneData.find(phone => phone.iso === countryCode) || {};
  if (phoneDataForCountry.phone) {
    const phoneNumber = phoneDataForCountry.phone;

    Array.from(document.querySelectorAll('a.support-phone-number')).forEach(el => {
      el.textContent = phoneNumber; // eslint-disable-line no-param-reassign
      el.setAttribute('href', `tel:${phoneNumber}`);
    });
  }
}

export async function performAlgoliaNearbySearch(hitsPerPage = 5) {
  return algoliaClient().search([
    {
      indexName: ALGOLIA_GEOGROUPING_INDEX,
      query: '',
      params: {
        facetFilters: ['type:Marketgeo'],
        aroundLatLngViaIP: true,
        getRankingInfo: true,
        hitsPerPage
      }
    }
  ]);
}

export function performAlgoliaNearbyMarketsSearch(locale) {
  return algoliaClient().search([
    {
      indexName: ALGOLIA_GEOGROUPING_INDEX,
      params: {
        hitsPerPage: MAX_NEARBY_MARKET,
        facetFilters: ['type:Marketgeo'],
        aroundRadius: LOCATION_MARKET_RADIUS_IN_METERS,
        aroundLatLngViaIP: true,
        attributesToRetrieve: ['id', 'name', 'slug', `name_${locale}`]
      }
    }
  ]);
}

export async function hasOnDemandBuildingAround() {
  try {
    const response = await algoliaClient().search([
      {
        indexName: varsFromServer.algoliaBuildingsIndex,
        params: {
          filters: 'on_demand_enabled:true',
          hitsPerPage: 1,
          attributesToRetrieve: ['id', 'name', 'on_demand_enabled'],
          aroundLatLngViaIP: true,
          aroundRadius: LOCATION_MARKET_RADIUS_IN_METERS
        }
      }
    ]);

    return !!response.results[0].hits[0];
  } catch (error) {
    return false;
  }
}

export function performAlgoliaNearbyBuildingsSearch(
  hitsPerPage = 1,
  radiusInMetersAroundIP = LOCATION_MARKET_RADIUS_IN_METERS,
  additionalAlgoliaParams = {}
) {
  return algoliaClient().search([
    {
      indexName: ALGOLIA_BUILDINGS_INDEX,
      params: {
        hitsPerPage,
        aroundRadius: radiusInMetersAroundIP,
        aroundLatLngViaIP: true,
        getRankingInfo: true,
        ...additionalAlgoliaParams
      }
    }
  ]);
}
